// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

import analytics from "../analytics/google_analytics";
window.analytics = analytics;

import "./bootstrap_custom.js";
import "select2";
import { I18n } from "i18n-js";
import translations from "/app/javascript/packs/locales.json";
window.i18n = new I18n(translations);
window.i18n.locale = "de";
import moment from "moment";
import "tempusdominus-bootstrap-4";
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context("../images", true);
const imagePath = name => images(name, true); // eslint-disable-line no-unused-vars

import "controllers";
import "@fortawesome/fontawesome-free/css/all.css";
import "../scss/application.scss";
import "tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.css";

moment.locale(document.documentElement.lang);

$.extend(true, $.fn.datetimepicker.Constructor.Default, {
  icons: {
    previous: "fas fa-angle-left",
    next: "fas fa-angle-right"
  }
});
